import { ChangeDetectionStrategy, Component, input } from '@angular/core';

export interface PtlTableColumn {
  key: string;
  label: string;
  align?: 'left' | 'center' | 'right';
  mono?: boolean;
}

@Component({
  selector: 'ptl-table',
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  templateUrl: './ptl-table.component.html',
  styleUrls: ['./ptl-table.component.scss'],
})
export class PtlTableComponent {
  columns = input<PtlTableColumn[]>([]);
  // eslint-disable-next-line @typescript-eslint/no-explicit-any -- generic data rows
  data = input<Record<string, any>[]>([]);
  variant = input<'default' | 'warm'>('default');
}
